var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "tooltip-panel" }, [
    _c("div", { staticClass: "tooltip-header" }, [_vm._v(_vm._s(_vm.title))]),
    _c("div", {
      staticClass: "tooltip-body",
      domProps: { innerHTML: _vm._s(_vm.description) },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }